import React from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useSelector, useDispatch } from "react-redux";
import useFetch from "../fetch";
import { sendStaffAppMetaData } from "../staffApp/eventTriggers";

function ChildWelfareHistoryFormModel() {
  const props = useSelector((state) => {
    return {
      show: state.ui.childWelfareHistoryModal.show,
      childWelfareHistory: state.ui.childWelfareHistoryModal.childWelfareHistory,
      action: state.ui.childWelfareHistoryModal.action,
      organizationName: state.organization.name,
      resident: state.resident,
      isStaffApp: state.config.isStaffApp,
      childWelfareHistoryTabDefaultMetaData: state.config.tab_default_meta_data.find(
        (tab) => tab.detail == "child_welfare_history"
      ),
    };
  });

  const dispatch = useDispatch();
  const fetch = useFetch();
  const closeModal = () =>
    dispatch({
      type: "CLOSE_RESOURCE_MODAL",
      payload: { resourceName: "childWelfareHistory" },
    });
  const updateField = (name, value) =>
    dispatch({
      type: "UPDATE_RESOURCE_FIELD",
      payload: { resourceName: "childWelfareHistory", name, value },
    });
  const deleteChildWelfareHistory = (childWelfareHistory) =>
    dispatch({ type: "DELETE_CHILD_WELFARE_HISTORY", payload: { childWelfareHistory } });
  const setDefaultStaffAppMetaData = () =>
    sendStaffAppMetaData(props.childWelfareHistoryTabDefaultMetaData);

  const updateResidentChildWelfareHistoriesAction = () => {
    return (dispatch, getState) => {
      const state = getState();
      var childWelfareHistories = { ...state.ui.childWelfareHistoryModal.childWelfareHistory, organization_id: state.organization.id }
      return fetch(
        `/organizations/${state.organization.name}/residents/${state.resident.id}.json`,
        {
          method: "PATCH",
          headers: {'Content-Type': 'application/json'},
          data: JSON.stringify({
            resident: {
              child_welfare_histories_attributes: [childWelfareHistories]
            },
          })
        }
      ).then((data) => {
        dispatch({
          type: "UPDATE_CHILD_WELFARE_HISTORY",
          payload: { childWelfareHistory: data.child_welfare_histories },
        });
      });
    };
  };

  const updateResidentChildWelfareHistories = (childWelfareHistory) => {
    const { organizationName, resident } = props;
    var childWelfareHistories = { ...childWelfareHistory, organization_id: props.resident.organization_id }
    return fetch(
      `/organizations/${organizationName}/residents/${resident.id}.json`,
      {
        method: "PATCH",
        headers: {'Content-Type': 'application/json'},
        data: JSON.stringify({
          resident: {
            child_welfare_histories_attributes: [childWelfareHistories]
          },
        })
      }
    );
  };

  const removeChildWelfareHistory = () => {
    updateResidentChildWelfareHistories({
      id: props.childWelfareHistory.id,
      _destroy: true,
    }).then(() => {
      deleteChildWelfareHistory(props.childWelfareHistory);
      if (props.isStaffApp) alert("Child Welfare History successfully deleted.");
      setDefaultStaffAppMetaData();
      closeModal();
    });
  };

  const saveChildWelfareHistory = () => {
    dispatch(updateResidentChildWelfareHistoriesAction()).then((data) => {
      if (props.isStaffApp) alert("Child Welfare History changes saved.");
      setDefaultStaffAppMetaData();
      closeModal();
    });
  };

  const { title, description, start_date, end_date, case_details } = props.childWelfareHistory;

  React.useEffect(() => {
    let saveChildWelfareHistoryFunction = (e) => {
      saveChildWelfareHistory();
    };
    document.addEventListener("saveChildWelfareHistory", saveChildWelfareHistoryFunction);
    return () =>
      document.removeEventListener(
        "saveChildWelfareHistory",
        saveChildWelfareHistoryFunction
      );
  }, []);

  return (
    <Modal
      animation={!props.isStaffApp}
      show={props.show}
      onHide={() => closeModal()}
    >
      {!props.isStaffApp && (
        <Modal.Header closeButton>
          <Modal.Title>Child Welfare History</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body className="p-4">
        <Form.Group controlId="childWelfareHistoryName">
          <Form.Label>Case Status</Form.Label>
          <Form.Control
            value={title}
            onChange={(e) => {
              updateField("title", e.target.value);
            }}
          />
        </Form.Group>
        <Form.Group controlId="childWelfareHistoryDescription">
          <Form.Label>
            Describe case in terms of duration, number of children, and ages of children
          </Form.Label>
          <Form.Control
            value={description}
            onChange={(e) => {
              updateField("description", e.target.value);
            }}
          />
        </Form.Group>
          <Form.Group controlId="childWelfareHistoryCaseDetails">
            <Form.Label>Please Enter Case #, ODHS Branch Name, Caseworker Name, Phone Number, and Case Dates</Form.Label>
            <Form.Control
              value={case_details}
              onChange={(e) => {
                updateField("case_details", e.target.value);
              }}
            />
          </Form.Group>
        <Row>
          <Col sm={6}>
            <Form.Group controlId="childWelfareHistoryStartDate">
              <Form.Label>Start Date</Form.Label>
              <DatePicker
                className="form-control"
                selected={start_date ? moment(start_date) : null}
                onChange={(date) => {
                  updateField(
                    "start_date",
                    date ? date.format("YYYY-MM-DD") : null
                  )
                }}
              />
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group controlId="childWelfareHistoryEndDate">
              <Form.Label>End Date</Form.Label>
              <DatePicker
                className="form-control"
                selected={end_date ? moment(start_date) : null}
                onChange={(date) => {
                  updateField(
                    "end_date",
                    date ? date.format("YYYY-MM-DD") : null
                  )
                }}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      {!props.isStaffApp ? (
        <Modal.Footer>
          {props.action === "edit" && (
            <Button
              variant="outline-danger"
              onClick={() => removeChildWelfareHistory(props.childWelfareHistory)}
            >
              Delete
            </Button>
          )}
          <Button variant="info" onClick={() => saveChildWelfareHistory()}>
            {props.action === "edit" ? "Update" : "Create"}
          </Button>
        </Modal.Footer>
      ) : (
        <div className="p-4">
          {props.action == "edit" && (
            <Button
              onClick={() => removeChildWelfareHistory(props.childWelfareHistory)}
              variant="outline-danger"
              className="w-100"
            >
              Delete
            </Button>
          )}
        </div>
      )}
    </Modal>
  );
}

export default ChildWelfareHistoryFormModel;
